module.exports = "/_next/static/images/muhammet-68ccd7e01a6e2d79258dfd7f08b93861.png";